import type { FC, PropsWithChildren } from 'react';
import { MdxProvider, SiteProvider } from '@anywayseo/tools';
import { useSite } from 'hooks';

import FooterExtra from './footer-extra';

type RootWrapperProps = PropsWithChildren;

const RootWrapper: FC<RootWrapperProps> = ({ children }) => {
  const { metadata, navigation, localization } = useSite();

  return (
    <SiteProvider
      metadata={metadata}
      navigation={navigation}
      localization={localization}
      config={{
        footer: {
          extra: <FooterExtra />,
        },
      }}
    >
      <MdxProvider>{children}</MdxProvider>
    </SiteProvider>
  );
};

export default RootWrapper;
